import { Controller } from '@hotwired/stimulus'

// Handles the "Signing you in…" interstitial swap: hides the form and
// shows the loading state once a sign-in form submits successfully.
export default class extends Controller {
  static targets = ["content", "loading"]

  #handleSubmitEnd = (event) => {
    if (!event.detail.success) return
    this.contentTarget.classList.add("hidden")
    this.loadingTarget.classList.remove("hidden")
  }

  connect() {
    this.element.addEventListener("turbo:submit-end", this.#handleSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.#handleSubmitEnd)
  }
}
